module.exports = __webpack_public_path__ + "img/shopping-basket.7c28ed9b.svg";